<template>
  <div class="app flex-row align-items-center" style="background-color: #f6f6f6 !important;">
    <div class="container">
      <!-- <b-row class="justify-content-center">
        <b-col md="8" lg="6">
          <b-card no-body class="p-4">
            <b-card-body class="text-center">
              <p class="text-muted">로그인 후, 가장 쉽게 웹서버를 보호하세요</p>
              <div class="relative title">
                <div class="absolute" style="font-size: 1.6rem; width: max-content; font-weight: bold; left:50%; transform:translateX(-50%); padding: 0 40px;">
                  {{custom && custom.slogan ? custom.slogan : 'F1-UWSS'}}
                </div>
              </div>
              <b-input-group class="mb-3">
                <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                <input type="text" class="form-control" placeholder="아이디" v-model="m.username" @keyup.enter="login()">
              </b-input-group>
              <b-input-group class="mb-4">
                <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                <input type="password" class="form-control" placeholder="비밀번호" v-model="m.password" @keyup.enter="login()">
              </b-input-group>
              <b-input-group class="mb-4" v-show="require_otp">
                <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                <input type="password" class="form-control" placeholder="OTP PIN" v-model="m.otp" @keyup.enter="login()">
              </b-input-group>
              <b-row>
                <b-col>
                  <b-button block variant="primary" class="px-4" @click="login()">
                    <i class="fa-solid fa-shield-halved mr-2"></i>
                    로그인
                  </b-button>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col>
                  <b-checkbox v-model="remember_username">아이디 저장</b-checkbox>
                </b-col>
                <b-col>
                  <small v-if="custom.version">v{{ custom.version }}</small>
                </b-col>
                <b-col>
                  <b-button variant="link" @click="reset()" class="float-right px-0">비밀번호 찾기</b-button>
                </b-col>
              </b-row>
              <hr>
              <b-row class="text-center">
                <b-col>
                  <Language />
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row> -->

      <div class="login">
        <div class="wrapper wrapper-login bg_img">
            <div class="container container-login">
                <!-- <div class="login_logo">
                    <img src="/F1C/assets/img/f1_logo.png" class="mx-auto" height="50">
                </div> -->
                <div class="bg_icon">
                    <img src="/F1C/assets/img/login_icon.png" class="mx-auto d-block">
                </div>
                <h3 class="text-center login_tit">LOGIN</h3>
                <p class="text-center font_20 font-weight-bold">
                  {{custom && custom.slogan ? custom.slogan : 'F1-UWSS'}} Console
                </p>
                <h3 class="text-center login_sub">로그인 하시면 더욱 다양한 서비스를 이용하실 수 있습니다.</h3>
                <div class="login-form">
                    <div class="form-group mb-1">
                        <input type="text" class="form-control" id="username" name="username" placeholder="아이디를 입력하세요" required v-model="m.username" @keyup.enter="login()">
                    </div>
                    <div class="form-group mb-1">
                      <input type="password" class="form-control" id="userpass" name="userpass" placeholder="Password" required v-model="m.password" @keyup.enter="login()">
                  </div>
                  <div class="form-group mb-1" v-show="require_otp">
                    <!-- <input type="text" class="form-control" id="userpass" name="userpass" placeholder="비밀번호를 입력하세요" required @keyup.enter="login()"> -->
                    <input type="password" class="form-control" placeholder="OTP PIN" v-model="m.otp" @keyup.enter="login()">
                  </div>
                  <div class="form-group py-2">
                      <div class="custom-control custom-radio">
                          <input type="checkbox" class="custom-control-input" id="customRadio" name="example1" v-model="remember_username">
                          <label class="custom-control-label m-0 font_16" for="customRadio">아이디 저장</label>
                          <!-- <b-checkbox v-model="remember_username">Remember</b-checkbox> -->
                      </div>
                      <div class="custom-control custom-radio float-right">
                          <Language />
                      </div>
                      <div class="custom-control custom-radio">
                        <input type="radio" class="custom-control-input" id="customRadio01" name="example1">
                        <!-- <label class="custom-control-label m-0 font_16" for="customRadio01">자동로그인</label> -->
                      </div>
                  </div>
                    <div class="form-group form-action-d-flex">
                      <button type="button" class="btn btn-primary btn-lg btn-block" @click="login()" @keyup.enter="login()">
                            로그인
                        </button>
                    </div>
                    <div class="login-account font_16">
                        <!-- <a href="#" class="link text-secondary">아이디찾기</a> -->
                        <a href="#" class="link text-secondary">
                          <small v-if="custom.version">v{{ custom.version }}</small>
                        </a>
                        <span class="px-1 dot">·</span>
                        <a href="#" @click="reset()" class="link text-secondary">패스워드찾기</a>
                    </div>
                </div>
                <div class="bg_logo">
                    <img src="/F1C/assets/img/login_icon.png" class="mx-auto d-block">
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
